import { clsx } from "clsx";
import { useState } from "react";

import { Table, TableHead } from "common/components/ui/TableV2";
import usePromotions from "common/datahooks/usePromotions";
import useWorkspaces from "common/datahooks/useWorkspaces";

import AgencySubscriptionCard from "../../AgencySubscriptionCard";
import WorkspacesTableRow from "./WorkspacesTableRow";

export default function PlanDetails() {
  const { agencyPlan } = usePromotions();
  const { workspaces } = useWorkspaces();

  const [editingWorkspaceId, setEditingWorkspaceId] = useState<string>();

  const detailCards = [
    {
      label: "Total seats",
      value: agencyPlan.license_count,
      valueClassName: "text-black-950",
    },
    {
      label: "Assigned seats",
      value: agencyPlan.license_count - agencyPlan.unassigned_license_count,
      valueClassName: "text-purple-600",
    },
    {
      label: "Available seats",
      value: agencyPlan.unassigned_license_count,
      valueClassName: "text-green-500",
    },
  ];

  return (
    <>
      <AgencySubscriptionCard isAgencyPage />
      <div className="flex gap-x-3 ">
        {detailCards.map(({ label, value, valueClassName }) => (
          <div
            key={label}
            className="flex flex-col gap-y-3 flex-1 p-4 border border-black-200 rounded-2xl"
          >
            <span className="text-sm-medium text-black-500">{label}</span>
            <span className={clsx(valueClassName, "text-2xl-bold")}>
              {value}
            </span>
          </div>
        ))}
      </div>
      <Table>
        <thead>
          <tr>
            <TableHead>Name</TableHead>
            <TableHead>Accounts</TableHead>
            <TableHead />
            <TableHead>Seats</TableHead>
            <TableHead className="w-28" />
          </tr>
        </thead>

        <tbody>
          {workspaces.map((workspace) => {
            const { id } = workspace;
            const isEditing = editingWorkspaceId === id;

            return (
              <WorkspacesTableRow
                key={id}
                workspace={workspace}
                isEditing={isEditing}
                toggleIsEditing={() => {
                  setEditingWorkspaceId(isEditing ? null : id);
                }}
              />
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
